import { render } from "./JumpDirectlyWeapp.vue?vue&type=template&id=045589c2&ts=true&lang=pug"
import script from "./JumpDirectlyWeapp.vue?vue&type=script&lang=ts"
export * from "./JumpDirectlyWeapp.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__